module.exports = __webpack_public_path__ + "media/trofi-poster.3fecb148.mp4";